import { render } from "./Password.vue?vue&type=template&id=627e4580"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"
script.render = render

export default script